import React from 'react';

import { TextEditor } from './TextEditor';

export const TextEditorAdapter: React.FC = () => {
  return <TextEditor />;
};

